import { create } from 'zustand';

export const SHELL_TABS = ['hunt', 'collection', 'ranks', 'you'] as const;
export type ShellTab = (typeof SHELL_TABS)[number];

export interface ProfileRoute {
  playerId: string;
  rank?: number;
  displayName?: string;
}

export interface Toast {
  id: number;
  text: string;
  /** CSS colour; defaults to ink. */
  color?: string;
  durationMs: number;
}

interface ShellState {
  tab: ShellTab;
  /** Another hunter's profile, shown over the tabs. */
  profile: ProfileRoute | null;
  toast: Toast | null;
  /** Set when a new service worker is waiting; calling it reloads into the new version. */
  applyUpdate: (() => void) | null;
  setUpdate: (apply: () => void) => void;
  select: (tab: ShellTab) => void;
  openProfile: (route: ProfileRoute) => void;
  closeProfile: () => void;
  showToast: (text: string, opts?: { color?: string; durationMs?: number }) => void;
  dismissToast: (id: number) => void;
}

let toastSeq = 0;

export const useShell = create<ShellState>((set) => ({
  tab: 'hunt',
  profile: null,
  toast: null,
  applyUpdate: null,
  setUpdate: (apply) => set({ applyUpdate: apply }),
  select: (tab) => set({ tab, profile: null }),
  openProfile: (profile) => set({ profile }),
  closeProfile: () => set({ profile: null }),
  showToast: (text, opts) => set({ toast: { id: ++toastSeq, text, color: opts?.color, durationMs: opts?.durationMs ?? 3000 } }),
  dismissToast: (id) => set((s) => (s.toast?.id === id ? { toast: null } : s)),
}));
